import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block mb-3">
        Kolor’ de la vivo, kolor’ de l’ espero, <br/>
        Kolor’ de l’ kreskaĵoj, florantaj sur Tero, <br/>
        Kolor’ de l’ arbaro, potenca kaj ombra, <br/>
        Kolor’ de l’ herbaro humila, sennombra.
      </p>

      <p class="poem-block mb-3">
        Kaj verda river’ en trankvila fluado, <br/>
        Kaj maro tempesta kun ondoj el jado, <br/>
        Kaj teraj donacoj – smerald’, malaĥito – <br/>
        La vivo jubilas sur Ter’ verdkovrita!
      </p>

      <p class="poem-block mb-3">
        Sed sama koloro – la stel’ esperanta. <br/>
        Do estu la stel’ nia ĉiam vivanta! <br/>
        La sama ideo – protekti naturon <br/>
        Kaj homan spiritan protekti kulturon. <br/>
        Sen ambaŭ ja ili la homo pereos, <br/>
        Se novan rigardon al mondo ne kreos.
      </p>

      <p class="poem-block mb-3">
        Sur nia planedo, komuna la domo, <br/>
        Nur lingvo kunigas naturon kaj homon. <br/>
        Ĝi kreskas en koroj honestaj kaj puraj: <br/>
        Ni kune protektos komunan naturon!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Verda koloro'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['NvJNdcqxExs'],
    itemAuthor: author.esp
  }
}
export default item;